import React, { Component } from "react";
import { compose, graphql } from "react-apollo";
import { CUISINES } from "../../graphql/queries/dishes";
import connect from "react-redux/es/connect/connect";
import ReactAutocomplete from "react-autocomplete";
import { webFont } from "../../config/theme";

class CuisinesAutocomplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cuisines: "",
      isFocused: false
    };
  }

  toggleFocus = () => {
    this.setState({ isFocused: !this.state.isFocused })
  };

  handleChange = (list, value) => {
    this.setState({ cuisine: value }, () => {
      this.props.onChange( value);
    });
  };

  handleClick = value => {
    this.props.onItemSelected(value);
    this.setState({ cuisine: value });
  };

  render() {
    let list = [];
    if (this.props.cuisinesList) {
      const {
        cuisinesList: { cuisines }
      } = this.props;
      list = cuisines;
    }
    if (!list) {
      return <p>Loading cusines ...</p>;
    }
    return (
      <ReactAutocomplete
        items={list}
        shouldItemRender={(item, value) =>
          item.toLowerCase().indexOf(value.toLowerCase()) > -1 &&
          value.length > 0
        }
        wrapperStyle={{
          background: "white"
        }}
        getItemValue={item => item}
        renderItem={(item, highlighted) => (
          <div
            key={new Date().getMilliseconds() + item}
            style={style.suggenstionBox}
          >
            <p style={style.suggestionText}> {item}</p>
          </div>
        )}
        value={this.state.cuisine}
        menuStyle={{
          zIndex: 100,
          maxHeight: 100,
          overflow: "auto",
          background: "white",
        }}
        onChange={e => this.handleChange(list, e.target.value)}
        onSelect={this.handleClick}
        renderInput={props => {
          return (
            <div className="group">
              {this.state.isFocused ? (
                <input
                  data-test-id={"entercuis-text"}
                  className="mat-input"
                  style={{width:'100%', borderBottomColor: '#ff8000', borderBottomWidth: 2}}
                  placeholder={"Enter cuisine"}
                  type="text"
                  onFocus={() => this.toggleFocus()}
                  onBlur={() => this.toggleFocus()}
                  {...props}
                  value={this.props.value}
                />
              ) : (
                <input
                  data-test-id={"entercuis-text"}
                  className="mat-input"
                  style={{width:'100%'}}
                  placeholder={"Enter cuisine"}
                  type="text"
                  onFocus={() => this.toggleFocus()}
                  onBlur={() => this.toggleFocus()}
                  {...props}
                  value={this.props.value}
                />
              )}
              <span className="highlight" />
              {/*<span className="bar" />*/}
            </div>
          );
        }}
      />
    );
  }
}

const mapSateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef
  };
};
const CuisinesWithData = compose(
  graphql(CUISINES, {
    name: "cuisinesList",
    options: props => ({
      variables: {
        country: "US"
      }
    })
  })
)(CuisinesAutocomplete);
const Cuisines = connect(mapSateToProps)(CuisinesWithData);
export default Cuisines;

const style = {
  cuisineText: {
    fontFamily: webFont
  },
  suggestionText: {
    padding: 5,
    fontFamily: webFont
  },
  suggenstionBox: {
    backgroundColor: "white",
    zIndex: 100,
    height: 30,
    borderBottom: "0.5px solid gray",
    cursor: "pointer"
  }
};
